import { CommonModule } from '@angular/common';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import * as i0 from "@angular/core";
export class PaginationControlsModule {
}
PaginationControlsModule.ɵfac = function PaginationControlsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PaginationControlsModule)(); };
PaginationControlsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PaginationControlsModule });
PaginationControlsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, DisabledModule] });
